<app-list-module-table
    variant="surface"
    [columns]="columns"
    [rows]="rows"
    [loading]="loading"
    [emptyMessage]="emptyMessage"
    rowTrackKey="id"
>
    <ng-template listCellDef="serial" let-row="row">{{ row.srNo }}</ng-template>

    <ng-template listCellDef="type" let-row="row">
        <span class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
            {{ row.type || '—' }}
        </span>
    </ng-template>

    <ng-template listCellDef="title" let-row="row">
        <button
            type="button"
            class="cursor-pointer border-0 bg-transparent p-0 text-left font-semibold text-primary hover:underline dark:text-white"
            (click)="open.emit(row)"
        >
            {{ row.title || '—' }}
        </button>
    </ng-template>

    <ng-template listCellDef="message" let-row="row">
        <span class="line-clamp-2 text-sm text-gray-600 dark:text-gray-300">{{ row.message || '—' }}</span>
    </ng-template>

    <ng-template listCellDef="status" let-row="row">
        <span
            class="inline-flex items-center rounded-full py-1 px-3 text-xs font-semibold"
            [class]="row.is_read
                ? 'text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-white/10'
                : 'text-primary bg-primary-light'"
        >
            {{ row.is_read ? 'Read' : 'Unread' }}
        </span>
    </ng-template>

    <ng-template listCellDef="date" let-row="row">{{ row.created_at | appDate }}</ng-template>

    <ng-template listCellDef="actions" let-row="row">
        @if (!row.is_read) {
            <button
                type="button"
                class="btn btn-sm ml-auto inline-flex w-max items-center gap-1 rounded-full border border-gray-200 bg-white py-1 px-2.5 text-xs dark:border-[#191e3a] dark:bg-[#0e1726]"
                (click)="markRead.emit({ row, event: $event })"
            >
                <icon-eye class="size-3.5 shrink-0" />
                Mark read
            </button>
        } @else {
            <span class="text-xs text-gray-400">—</span>
        }
    </ng-template>
</app-list-module-table>
